import { useReadPerson } from '@aibees/elephant/hooks';
import { Chip } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { PersonBadgesProps as Props } from './types';

export const PersonBadges = memo(({ className, personId }: Props) => {
  const { data } = useReadPerson(personId);

  const badges = data?.memberBadges;
  const influencer = !!data?.statistics?.network?.influencer;

  return (
    <Styled.Wrapper
      className={classnames('PersonBadges', className)}
      sx={SX.root}
    >
      {badges?.verified && (
        <Chip
          color="primary"
          startIcon="verified"
          label="Verified Account"
          size="small"
          shape="square"
          variant="filled"
        />
      )}

      {badges?.premium && (
        <Chip
          color="warning"
          startIcon="premium"
          label="Paid Social Members"
          size="small"
          shape="square"
          variant="filled"
        />
      )}

      {influencer && (
        <Chip
          color="purple"
          startIcon="campaign-outline"
          label="Influencer"
          size="small"
          shape="square"
          variant="filled"
        />
      )}
      {badges?.openToWork && (
        <Chip
          color="success"
          startIcon="work-alert-outline-rounded"
          label="Open to work"
          size="small"
          shape="square"
          variant="filled"
        />
      )}
      {badges?.hiring && (
        <Chip
          color="violet"
          startIcon="grid-3x3-outline"
          label="Hiring"
          size="small"
          shape="square"
          variant="filled"
        />
      )}
      {badges?.creator && (
        <Chip
          color="rose"
          startIcon="art-track"
          label="Creator"
          size="small"
          shape="square"
          variant="filled"
        />
      )}
    </Styled.Wrapper>
  );
});

PersonBadges.displayName = 'PersonBadges';
